import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function EventsPage() {
  const [events, setEvents] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetch("https://ricgop.online/api/events/read_events.php")
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") setEvents(data.events);
      });
  }, []);

  const handleDelete = (id) => {
    if (!window.confirm("Are you sure you want to delete this event?")) return;

    fetch(`https://ricgop.online/api/events/delete_event.php?id=${id}`, {
      method: "DELETE",
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          alert("Event deleted successfully.");
          setEvents(events.filter((event) => event.id !== id));
        }
      });
  };

  const cardStyle = {
    backgroundColor: "#1f1f1f",
    color: "#fff",
    borderRadius: "16px",
    overflow: "hidden",
    boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
    transition: "transform 0.3s ease",
  };

  const imageStyle = {
    height: "180px",
    width: "100%",
    objectFit: "cover",
    borderTopLeftRadius: "16px",
    borderTopRightRadius: "16px",
  };

  const badgeStyle = {
    fontSize: "0.75rem",
    padding: "4px 8px",
    borderRadius: "8px",
    marginRight: "6px",
  };

  const buttonStyle = {
    borderRadius: "10px",
  };

  return (
    <div className="container py-4 text-white">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="fw-bold">🎉 All Events</h2>
        <button
          className="btn btn-success shadow"
          style={buttonStyle}
          onClick={() => navigate("/admin/events/create")}
        >
          ➕ Add New Event
        </button>
      </div>

      <div className="row g-4">
        {events.map((event) => (
          <div className="col-md-6 col-lg-4" key={event.id}>
            <div className="card h-100" style={cardStyle}>
              <img
                src={`https://ricgop.online/assets/img/${event.image_url}`}
                alt={event.title}
                style={imageStyle}
              />
              <div className="card-body">
                <h5 className="card-title fw-semibold">{event.title}</h5>
                <p className="mb-1">
                  <span className="badge bg-primary" style={badgeStyle}>
                    Author
                  </span>{" "}
                  {event.author_name}
                </p>
                <p className="mb-1">
                  <span className="badge bg-info text-dark" style={badgeStyle}>
                    Date
                  </span>{" "}
                  {event.published_date} ({event.published_month})
                </p>
                <p className="mb-2">
                  <span
                    className="badge bg-warning text-dark"
                    style={badgeStyle}
                  >
                    Views
                  </span>{" "}
                  {event.views}
                </p>
                <div className="d-flex justify-content-between">
                  <button
                    className="btn btn-sm btn-outline-primary"
                    style={buttonStyle}
                    onClick={() => navigate(`/admin/events/edit/${event.id}`)}
                  >
                    ✏️ Edit
                  </button>
                  <button
                    className="btn btn-sm btn-outline-danger"
                    style={buttonStyle}
                    onClick={() => handleDelete(event.id)}
                  >
                    🗑️ Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
        {events.length === 0 && (
          <div className="col-12 text-center text-muted">
            <h5>No events found.</h5>
          </div>
        )}
      </div>
    </div>
  );
}

export default EventsPage;
